export { default } from './CustomerInformationsCard';
